import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import * as Sentry from '@sentry/react';

const useUserStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoggedIn: false,

      login: (user, token) => {
        localStorage.setItem('token', token);
        Sentry.setUser({ id: user._id || user.id, username: user.nombre, email: user.correo });
        set({ user, token, isLoggedIn: true });
      },

      logout: () => {
        localStorage.removeItem('token');
        Sentry.setUser(null);
        set({ user: null, token: null, isLoggedIn: false });
      },

      updateUserData: (data) => {
        set((state) => ({ user: { ...state.user, ...data } }));
      },
    }),
    {
      name: 'user-storage',
    }
  )
);

export default useUserStore;
